import { RefObject, useEffect } from 'react';

interface UseScrollProps {
  element: RefObject<HTMLDivElement | null>;
  requestInProgress: boolean;
}

const useScroll = ({ element, requestInProgress }: UseScrollProps) => {
  useEffect(() => {
    if (requestInProgress && element && element.current) {
      element.current.scrollTo(0, 0);
    }
  }, [element, requestInProgress]);
};

export default useScroll;
